import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBHorizontalScrollItem from './SBHorizontalScrollItem';

@Component({
    components: {},
})
export default class SBHorizontalScroll extends Mixins(SBComponentVue) {
    private click: boolean = false;
    private startX: number = 0;
    private endX: number = 0;
    private index: number = 0;
    private items: SBHorizontalScrollItem[] = [];

    public moveLeft(left: number, fixed: boolean) {
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].setLeft(i - left, fixed);
        }
    }

    public setIndex(index: number) {
        this.index = index;
        this.moveLeft(this.index, true);
    }

    public setChild(item: SBHorizontalScrollItem) {
        this.items.push(item);
        this.moveLeft(this.index, true);
    }

    public left() {
        this.index -= 1;
        if (this.index < 0) this.index = this.items.length - 1;
        this.moveLeft(this.index, true);
    }

    public right() {
        this.index += 1;
        if (this.index >= this.items.length) this.index = 0;
        this.moveLeft(this.index, true);
    }

    public move(x: number) {
        let div: HTMLElement = <HTMLElement>this.$refs.SBHorizontalScroll;
        let m = ((this.startX - x) / div.clientWidth * 1.5);
        return m;
    }

    public dragstart(x: number) {
        this.click = true;
        this.startX = x;
        this.endX = x;
    }

    public drag(x: number) {
        if (!this.click) return;
        this.endX = x;
        this.moveLeft(this.index + this.move(x), false);
    }

    public dragend() {
        let move = Math.round(this.move(this.endX));
        this.index += move;
        if (this.index < 0) this.index = 0;
        if (this.index > this.items.length - 1) this.index = this.items.length - 1;
        this.moveLeft(this.index, true);

        this.startX = 0;
        this.endX = 0;
        this.click = false;
    }

}
